import { Component, Input, QueryList, ContentChildren, AfterContentInit } from '@angular/core';

import { StepTitleDirective } from './step-title.directive';
import { StepContentDirective } from './step-content.directive';

@Component({
    selector: 'aa-step',
    template: '',
    styleUrls: [],
    standalone: false
})
export class StepComponent implements AfterContentInit
{
    private static nextId: number = 0;
    @Input() title: string;
    @Input() active: boolean = false;
    @Input() disabled: boolean = false;
    @Input() valid?: boolean = null;
    @ContentChildren(StepTitleDirective, { descendants: false }) titleTemplates: QueryList<StepTitleDirective>;
    @ContentChildren(StepContentDirective, { descendants: false }) contentTemplates: QueryList<StepContentDirective>;
    public titleTpl: StepTitleDirective | null;
    public contentTpl: StepContentDirective | null;
    public stepId: number;
    public deactivated: boolean = false;

    ngAfterContentInit ()
    {
        this.titleTpl = this.titleTemplates.first;
        this.contentTpl = this.contentTemplates.first;
    }
}
